import React from "react";
import { gql } from "@apollo/client";
import { graphql } from "@apollo/client/react/hoc";
import QuestionsTemplate from "../../components/Questions/QuestionsTemplate";

class QuestionsContainer extends React.Component {
  render() {
    const { loading, error, provincial } = this.props;
    if (loading) return null;
    if (error) return null;
    return (
      <QuestionsTemplate
        questions={provincial?.questions}
        page={provincial?.page}
        {...this.props}
      />
    );
  }
}

const QUESTIONS_QUERY = gql`
  query getQuestions($site: String!) {
    provincial(site: $site) {
      questions(first: 5) {
        id
        slug
        excerpt {
          rendered
        }
        title {
          rendered
        }
        content {
          rendered
        }
        featured_media {
          id
          source_url
          title {
            rendered
          }
          media_details {
            sizes {
              medium_large {
                source_url
              }
            }
          }
        }
        acf
      }
      page(slug: "questions") {
        id
        slug
        seo
        excerpt {
          rendered
        }
        title {
          rendered
        }
        content {
          rendered
        }
        featured_media {
          id
          source_url
          title {
            rendered
          }
        }
        hero {
          headline
          cta_type
          cta_group {
            title
            link_label
            link_url
          }
          background_image {
            url
          }
          focus_point
        }
      }
    }
  }
`;

const withQuestions = graphql(QUESTIONS_QUERY, {
  options: (props) => {
    let url;
    if (process.browser) {
      url = window.location.host;
    } else {
      url = props.url;
    }

    return {
      variables: {
        site: url,
      },
    };
  },
  props: ({ data }) => ({ ...data }),
});

export default withQuestions(QuestionsContainer);
